export default {
  name: '导航页',
  label: {
    singlePage: '单页面内跳转',
    pageTitle: '页面标题',
    background: '背景图',
    childPageTitle: '子菜单页面标题',
    childBackground: '子菜单页面背景图',
    page: '页面',
    menuLabel: '菜单名称',
    textColor: '字体颜色',
    fontSize: '字体大小',
    lineColor: '底部线条颜色',
    linePadding: '底部线条间距',
    hasSubMenu: '有子菜单',
    useParent: '使用父级配置',
    sameWithMenuLabel: '使用菜单名称',
    menuIndex: '第 {index} 级菜单',
    activeSubMenu: '激活（显示/使用）子菜单',
    subMenuCount: '{count} 个子菜单',
    isRichText: '使用富文本',
    addMenu: '添加菜单',
    editMenu: '编辑菜单',
    pagePadding: '子菜单页留白',
    topPadding: '顶部留白',
    horizontalPadding: '左右留白',
    bottomBtn: '底部按钮',
    leftBottomBtn: '底部左侧按钮',
    rightBottomBtn: '底部右侧按钮'
  },
  btn: {
    addMenu: '添加一级菜单',
    addSubMenu: '添加子菜单'
  },
  message: {
    emptyMenuListTip: '请点击按钮添加菜单'
  }
}
